import React, { FC, useRef } from 'react';
import Modal from "../components/Modal";
import Image from "../components/image"
import Styles from "../styles/TutorialModal.module.scss";
import Slider from "react-slick";
import useDetectDevice from "../hooks/useDetectDevice"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'

type slideType = {
    title: string
    image: string
}

type Props = {
    closeModal: () => void
    slideList: slideType[]
}

const TutorialModal: FC<Props> = ( {
    closeModal,
    slideList
} ) => {

    const sliderRef = useRef<Slider>( null )
    const { isPC } = useDetectDevice()
    const SP_PWA = ( useDetectDevice().isPWA && !isPC )

    const renderTutorialContent = () =>
        slideList.map( ( slide, index ) =>
            <div key={ index } className={ Styles.image_container } style={ { overflow: "hidden" } }>
                <h2 className={ Styles.title }>{ slide.title }</h2>
                <Image
                    className={ `${ SP_PWA ? "" : Styles.not_pwa_image } ${ Styles.tutorial_image_SP }` }
                    filename={ slide.image }
                    style={ { width: "90vw", maxHeight: "60vh", objectFit: "contain" } } />
                <Image
                    className={ `${ SP_PWA ? "" : Styles.not_pwa_image } ${ Styles.tutorial_image_PC }` }
                    filename={ "PC_" + slide.image }
                    style={ { width: "40vw", objectFit: "contain" } } />
                <div className={ `${ Styles.index_container } ${ SP_PWA ? "" : Styles.not_pwa }` } style={ slideList.length === 1 ? { display: "none" } : {} }>{ index + 1 } / { slideList.length }</div>
                { index + 1 !== slideList.length ?
                    <div className={ `${ Styles.next_icon_arrow_container } ${ SP_PWA ? "" : Styles.not_pwa }` }
                        onClick={ () => sliderRef.current && sliderRef.current.slickGoTo( index + 1 ) }>
                        <FontAwesomeIcon icon={ faAngleDoubleRight } className={ Styles.next_icon_arrow } />
                    </div>
                    :
                    <span
                        onClick={ () => closeModal() }
                        className={ `${ Styles.close_text } ${ SP_PWA ? "" : Styles.not_pwa }` }>
                        閉じる
                    </span>
                }
            </div>
        )


    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <Modal
            visible={ true }
            closeModal={ () => closeModal() }
            closeModalIconVisible={ true }
            style={ { overflow: "hidden", zIndex: 11, } }>
            <Slider ref={ sliderRef } { ...settings }>
                { renderTutorialContent() }
            </Slider>
        </Modal>
    )
}


export default TutorialModal
